module.exports = __webpack_public_path__ + "assets/b65.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b65.png
// module id = 655
// module chunks = 0